import { useEffect, useRef } from 'react'

const STEP_HASH_PARAM_NAME = 'schritt'
const STEP_PARAM_REGEX = /schritt\d+/

export const useUrlStepTracker = ({
  stepIndex,
  triggerStepForward,
  triggerStepBackward,
  isTransitioningBetweenSteps
}) => {
  //Have to use refs because logic happens inside event listeners
  const visibleStepIndex = useRef(stepIndex + 1)
  const navigation = useRef({
    triggerStepForward,
    triggerStepBackward,
    isTransitioningBetweenSteps
  })
  visibleStepIndex.current = stepIndex + 1
  navigation.current = {
    triggerStepForward,
    triggerStepBackward,
    isTransitioningBetweenSteps
  }

  const pushStepNumberToUrl = () => {
    const { href } = window.location
    const url = href.includes(STEP_HASH_PARAM_NAME)
      ? href.replace(
          STEP_PARAM_REGEX,
          `${STEP_HASH_PARAM_NAME}${visibleStepIndex.current}`
        )
      : `${href}#${STEP_HASH_PARAM_NAME}${visibleStepIndex.current}`
    if (url !== href) {
      history.pushState({}, '', url)
    }
  }

  useEffect(pushStepNumberToUrl, [visibleStepIndex.current])

  const handleBrowserNavigationClick = () => {
    const adjustActiveStepIndex = ({
      currentTarget: {
        location: { hash }
      }
    }) => {
      if (STEP_PARAM_REGEX.test(hash)) {
        const stepNumberFromUrl = Number(
          STEP_PARAM_REGEX.exec(hash)[0].replace(STEP_HASH_PARAM_NAME, '')
        )
        const browserBackButtonTriggered =
          stepNumberFromUrl < visibleStepIndex.current
        const browserForwardButtonTriggered =
          stepNumberFromUrl > visibleStepIndex.current

        // transition and url change are triggered right after step submission.
        // during transition, we disable moving back with browser navigation.
        // this is why we trigger moving forward in history if isTransitioningBetweenSteps=true to immediately revert url
        if (navigation.current.isTransitioningBetweenSteps) {
          if (browserBackButtonTriggered) {
            history.forward()
          }
          if (browserForwardButtonTriggered) {
            history.back()
          }
        } else {
          if (browserBackButtonTriggered) {
            navigation.current.triggerStepBackward()
          }
          if (browserForwardButtonTriggered) {
            navigation.current.triggerStepForward()
          }
        }
      }
    }

    window.addEventListener('popstate', adjustActiveStepIndex)

    return () => window.removeEventListener('popstate', adjustActiveStepIndex)
  }

  useEffect(handleBrowserNavigationClick, [])
}
